import {
  QueryKey,
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { api } from '../../../utils/api';
import { ApiErrorResponse, ApiResponse } from '../../../constant/api';

interface BulkCtaButtonSubmitRequest {
  historyId: string;
  linkRecord: {
    id: string;
    page: number;
    url: string;
  };
}

export const postBulkCtaButton = ({
  historyId,
  linkRecord,
}: BulkCtaButtonSubmitRequest) => {
  return api.post<ApiResponse<unknown>>('/v2/viewer/submit/link', {
    historyId,
    linkRecord,
  });
};

const useBulkCtaButtonSubmit = <TError = AxiosError<ApiErrorResponse>>(
  options?: UseMutationOptions<
    AxiosResponse<ApiResponse<unknown>>,
    TError,
    BulkCtaButtonSubmitRequest,
    QueryKey
  >,
): UseMutationResult<
  AxiosResponse<ApiResponse<unknown>>,
  TError,
  BulkCtaButtonSubmitRequest,
  QueryKey
> => {
  return useMutation(postBulkCtaButton, { ...options });
};

export default useBulkCtaButtonSubmit;
